import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { VpnLinkedState } from '../../api/core';
import { Router } from '../devices.models';

@Component({
    selector: 'liebherr-link-state',
    templateUrl: 'link-state.component.html',
    styleUrls: ['link-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkStateComponent implements OnChanges {
    @Input() device?: Router;

    VPN_STATE = VpnLinkedState;

    stateData$ = new BehaviorSubject<{ tooltip: string; style: string } | undefined>(undefined);

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.device) {
            if (this.device?.vpnState === this.VPN_STATE.Linked) {
                if (this.device.online) {
                    this.stateData$.next({ tooltip: 'DEVICES.CONNECTION.LINKED', style: 'linked online' });
                } else {
                    this.stateData$.next({ tooltip: 'DEVICES.CONNECTION.RESERVED', style: 'linked offline' });
                }
            } else {
                this.stateData$.next({ tooltip: 'DEVICES.CONNECTION.NOT_LINKED', style: 'unlinked' });
            }
        }
    }
}
